import { ModalId } from '@/config/modalIds'

// Vuex State for Bookings
export interface OpenState {
  openSet: Set<ModalId>
}

// Initial state
const state: OpenState = {
  openSet: new Set(),
}

// Mutations
const mutations = {
  open(state: OpenState, idToOpen: ModalId) {
    state.openSet.add(idToOpen)
  },
  close(state: OpenState, idToOpen: ModalId) {
    state.openSet.delete(idToOpen)
  },
  toggle(state: OpenState, idToToggle: ModalId) {
    if (state.openSet.has(idToToggle)) {
      state.openSet.add(idToToggle)
    } else {
      state.openSet.delete(idToToggle)
    }
  },
}
// Actions
const actions = {}

// Getters
const getters = {
  openSet: (state: OpenState): Set<ModalId> => state.openSet,
  isOpen:
    (state: OpenState) =>
    (id: ModalId): boolean => {
      return state.openSet.has(id)
    },
}

// Export the Vuex module
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
